export default "__VITE_ASSET__7x4axeHJ__"